import { Phone, MapPin } from "lucide-react";

export default function PublicHero({ customer, createdAt }) {
  const place = [customer.location, customer.city].filter(Boolean).join(", ");
  const dateLabel = new Date(createdAt).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  return (
    <div className="mb-6">
      <div className="overline text-[#C5A880] mb-2">Quotation</div>
      <h1 className="font-display text-3xl sm:text-4xl font-bold leading-tight">
        For {customer.name}
      </h1>
      <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1.5 text-sm text-white/60">
        {customer.mobile && (
          <span className="inline-flex items-center gap-1.5">
            <Phone size={13} /> {customer.mobile}
          </span>
        )}
        {place && (
          <span className="inline-flex items-center gap-1.5">
            <MapPin size={13} />
            {place}
          </span>
        )}
        <span className="text-white/40">{dateLabel}</span>
      </div>
    </div>
  );
}
